import { QueryCache, QueryClient } from "@tanstack/react-query";

// Create the react query client
export const queryClient = new QueryClient({
    queryCache: new QueryCache(),
});

export type QueryInvalidateOption = "Invalidate" | "Remove";
